import { HttpInterceptorFn } from '@angular/common/http';
import { LangEnum } from '@shared/constants/lang.enum';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const secureRequest = request.clone({
    setHeaders: {
      'strict-transport-security': 'max-age=15768000',
      'x-xss-protection': '1 ; mode=block',
      country: LangEnum.KH,
    },
  });

  return next(secureRequest);
};
